import React from "react";

import LSRgH1HeadLine from "./text/linSeedKr/Rg/lsRgH1HeadLine";
import useDisplay from "../../hooks/useDisplay";

function Empty({ title, style }) {
  const { isMobile } = useDisplay();

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "300px",
          ...style,
        }}
      >
        <img
          style={{
            width: 20,
            height: 20,
            marginBottom: 10,
          }}
          src={"/assets/icons/empty.png"}
          alt="empty"
        />
        <LSRgH1HeadLine
          style={{
            color: "#6F7480",
            fontSize: isMobile ? 12 : 16,
            lineHeight: isMobile ? "14.4px" : "22.4px",
          }}
        >
          {title}
        </LSRgH1HeadLine>
      </div>
    </>
  );
}

export default Empty;
